import React from 'react'
import { StrictOmit } from '../utils/strictOmit'
import { DEFAULT_IMG_SIZES, getSrcSet, Img, ImgProps } from './img'

export type PictureSources = ({ sizes?: string; media: string } & Pick<ImgProps, 'src' | 'crops'>)[]

export const Picture = ({
  pictureSources,
  crops,
  imgRef,
  ...props
}: StrictOmit<ImgProps, 'src'> & { pictureSources: PictureSources }) => {
  const firstPictureSource = pictureSources[0]
  return (
    firstPictureSource !== undefined && (
      <picture>
        {pictureSources.map((source, i) =>
          source.crops && source.crops.length > 0 ? (
            <source
              key={i}
              media={source.media}
              srcSet={getSrcSet(source.crops)}
              sizes={source.sizes || DEFAULT_IMG_SIZES}
            />
          ) : (
            <source key={i} media={source.media} srcSet={source.src} />
          )
        )}
        <Img {...props} imgRef={imgRef} src={firstPictureSource.src} crops={firstPictureSource.crops} />
      </picture>
    )
  )
}
